<template>
    <div class="package-service">
        <div id="container" class="mail_service">
            <div class="tab_container">
                <div class="tab_title">包装服务</div>
            </div>
            <div class="package-services">
                <div class="nav">
                    <div class="pre-desc">
                        <div class="desc">
                            <h3 class="desc-title">服务介绍</h3>
                            <p class="desc-detail">为了更好的保障快件安全，顺丰为您提供更专业、环保、便捷和高效的包装服务</p>
                        </div>
                        <div class="desc">
                            <h3 class="desc-title">服务特性</h3>
                            <p class="desc-detail">为客户提供抗震、减压、缓冲、保温等多样化、专业化的包装</p>
                        </div>
                        <div class="desc">
                            <h3 class="desc-title">服务范围</h3>
                            <p class="desc-detail">中国内地地区寄出快件</p>
                        </div>
                    </div>
                    <h3 class="title">包装材料介绍</h3>
                    <div class="list-title clear">
                        <div :class="{ active: type === 'normal' }" @click="changeType('normal')"><span>常规包装</span></div>
                        <div :class="{ active: type === 'circulation' }" @click="changeType('circulation')"><span>循环包装</span></div>
                        <div :class="{ active: type === 'temperatureControl' }" @click="changeType('temperatureControl')"><span>温控包装</span></div>
                        <div :class="{ active: type === 'buffer' }" @click="changeType('buffer')"><span>缓冲包装</span></div>
                        <div :class="{ active: type === 'wooden' }" @click="changeType('wooden')"><span>木质包装</span></div>
                    </div>
                </div>
                <section v-show="type === 'normal'" data-toggle="#normal">
                    <div class="tab-img">
                        <div class="tab-list clear">
                            <img src="@/assets/images/package-service/carton.png" alt="包装材料展示图片" />
                            <div class="content">
                                <p class="name">纸箱</p>
                                <p class="description">抗震防护，方便安全；用于各类物品的外包装</p>
                            </div>
                        </div>
                        <div class="tab-list clear">
                            <img src="@/assets/images/package-service/document-seal.png" alt="包装材料展示图片" />
                            <div class="content">
                                <p class="name">文件封</p>
                                <p class="description">纸质文件文档专属包装；用于纸质文件文档类产品的包装</p>
                            </div>
                        </div>
                        <div class="tab-list clear">
                            <img src="@/assets/images/package-service/plastic-bag.png" alt="包装材料展示图片" />
                            <div class="content">
                                <p class="name">包装胶袋</p>
                                <p class="description">结实耐用，防水；用于纺织类等软性物品包装</p>
                            </div>
                        </div>
                        <div class="tab-list clear">
                            <img src="@/assets/images/package-service/braided-material.png" alt="包装材料展示图片" />
                            <div class="content">
                                <p class="name">编织材料</p>
                                <p class="description">结实耐用，防腐环保；用于防潮要求较高的服装鞋帽、棉类、布匹、丝绸制品等</p>
                            </div>
                        </div>
                    </div>
                    <div class="fee">
                        <p class="fee-title">纸箱收费标准</p>
                        <table class="three">
                            <tbody>
                                <tr>
                                    <th>包装名称</th>
                                    <th>尺寸</th>
                                    <th>价格</th>
                                </tr>
                                <tr>
                                    <td>纸箱F1</td>
                                    <td>20cm*15cm*10cm</td>
                                    <td>1元/个</td>
                                </tr>
                                <tr>
                                    <td>纸箱F2s</td>
                                    <td>20cm*20cm*15cm</td>
                                    <td>2元/个</td>
                                </tr>
                                <tr>
                                    <td>纸箱F2</td>
                                    <td>30cm*20cm*15cm</td>
                                    <td>2元/个</td>
                                </tr>
                                <tr>
                                    <td>纸箱F3</td>
                                    <td>30cm*25cm*20cm</td>
                                    <td>3元/个</td>
                                </tr>
                                <tr>
                                    <td>纸箱F4</td>
                                    <td>40cm*30cm*20cm</td>
                                    <td>4元/个</td>
                                </tr>
                                <tr>
                                    <td>纸箱F5</td>
                                    <td>40cm*30cm*30cm</td>
                                    <td>5元/个</td>
                                </tr>
                                <tr>
                                    <td>纸箱F6s</td>
                                    <td>60cm*40cm*30cm</td>
                                    <td>6元/个</td>
                                </tr>
                                <tr>
                                    <td>纸箱F6</td>
                                    <td>70cm*40cm*32cm</td>
                                    <td>6元/个</td>
                                </tr>
                                <tr>
                                    <td>抗压纸箱中号</td>
                                    <td>50cm*30cm*50cm</td>
                                    <td>10元/个</td>
                                </tr>
                                <tr>
                                    <td>抗压纸箱大号</td>
                                    <td>60cm*50cm*40cm</td>
                                    <td>15元/个</td>
                                </tr>
                                <tr>
                                    <td>纸箱红酒1瓶装</td>
                                    <td>12.5cm*12.5cm*37cm</td>
                                    <td>2元/个</td>
                                </tr>
                                <tr>
                                    <td>纸箱红酒2瓶装</td>
                                    <td>12.5cm*21.2cm*37cm</td>
                                    <td>2元/个</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="fee">
                        <p class="fee-title">文件封收费标准</p>
                        <table class="three">
                            <tbody>
                                <tr>
                                    <th>包装名称</th>
                                    <th>尺寸</th>
                                    <th>价格</th>
                                </tr>
                                <tr>
                                    <td>文件封小号</td>
                                    <td>28.4cm*21.5cm</td>
                                    <td>免费</td>
                                </tr>
                                <tr>
                                    <td>文件封大号</td>
                                    <td>33cm*24.5cm</td>
                                    <td>免费</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="fee">
                        <p class="fee-title">包装胶袋收费标准</p>
                        <table class="three">
                            <tbody>
                                <tr>
                                    <th>包装名称</th>
                                    <th>尺寸</th>
                                    <th>价格</th>
                                </tr>
                                <tr>
                                    <td>包装胶袋中号</td>
                                    <td>40.5cm*28cm*0.05mm</td>
                                    <td>免费</td>
                                </tr>
                                <tr>
                                    <td>包装胶袋大号</td>
                                    <td>46.5cm*38cm*0.05mm</td>
                                    <td>免费</td>
                                </tr>
                                <tr>
                                    <td>包装胶袋特大号</td>
                                    <td>61cm*54cm*0.05mm</td>
                                    <td>免费</td>
                                </tr>
                            </tbody>
                        </table>
                        <div class="fee-mark">
                            <p>注：</p>
                            <div><p>特殊协议客户的文件封及包装胶袋的收费标准以具体约定为准</p></div>
                        </div>
                    </div>
                    <div class="fee">
                        <p class="fee-title">编织材料收费标准</p>
                        <table class="three">
                            <tbody>
                                <tr>
                                    <th>包装名称</th>
                                    <th>尺寸</th>
                                    <th>价格</th>
                                </tr>
                                <tr>
                                    <td>编织袋小号</td>
                                    <td>80cm*60cm</td>
                                    <td>1元/个</td>
                                </tr>
                                <tr>
                                    <td>编织袋大号</td>
                                    <td>120cm*100cm</td>
                                    <td>1元/个</td>
                                </tr>
                                <tr>
                                    <td>防水编织袋中号</td>
                                    <td>100cm*80cm</td>
                                    <td>10元/个</td>
                                </tr>
                                <tr>
                                    <td>防水编织袋大号</td>
                                    <td>150cm*120cm</td>
                                    <td>15元/个</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="type-mark">
                        <p>注：</p>
                        <div><p>以上收费标准及实际可提供的包装可能因服务（产品）或所在地区不同而有所差异，详情请咨询当地收派员</p></div>
                    </div>
                </section>
                <section v-show="type === 'circulation'" data-toggle="#normal">
                    <div class="tab-img">
                        <div class="tab-list clear">
                            <img src="@/assets/images/package-service/circulation.png" alt="包装材料展示图片" />
                            <div class="content">
                                <p class="name">丰多宝π-BOX</p>
                                <p class="description">循环使用，顺丰回收，抗震防护，方便安全，用于各类物品的外包装</p>
                            </div>
                        </div>
                    </div>
                    <div class="fee">
                        <p class="fee-title">循环箱收费标准</p>
                        <table class="three">
                            <tbody>
                                <tr>
                                    <th>包装名称</th>
                                    <th>尺寸</th>
                                    <th>价格</th>
                                </tr>
                                <tr>
                                    <td>丰多宝π-BOXS号箱</td>
                                    <td>25cm*20cm*15cm</td>
                                    <td>2元/次</td>
                                </tr>
                                <tr>
                                    <td>丰多宝π-BOX3号箱</td>
                                    <td>30cm*25cm*20cm</td>
                                    <td>3元/次</td>
                                </tr>
                                <tr>
                                    <td>丰多宝π-BOX4号箱</td>
                                    <td>40cm*30cm*20cm</td>
                                    <td>4元/次</td>
                                </tr>
                                <tr>
                                    <td>丰多宝π-BOX5号箱</td>
                                    <td>40cm*30cm*30cm</td>
                                    <td>5元/次</td>
                                </tr>
                                <tr>
                                    <td>丰多宝π-BOX6号箱</td>
                                    <td>60cm*40cm*30cm</td>
                                    <td>6元/次</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="type-mark">
                        <p>注：</p>
                        <div><p>具体收费标准及实际可提供的包装可能因服务（产品）或所在地区不同而有所差异，详情请咨询当地收派员或者销售</p></div>
                    </div>
                </section>
                <section v-show="type === 'temperatureControl'" data-toggle="#temperatureControl">
                    <div class="tab-img three">
                        <div class="tab-list">
                            <img src="@/assets/images/package-service/ice-bag.png" alt="包装材料展示图片" />
                            <div class="content">
                                <span class="aicon-arrow-up"></span>
                                <p class="name">冰袋</p>
                                <p class="description">吸热，保温；用于生鲜件的箱内降温，如水果、海鲜、肉类等</p>
                            </div>
                        </div>
                        <div class="tab-list">
                            <img src="@/assets/images/package-service/polystyrene-box.png" alt="包装材料展示图片" />
                            <div class="content">
                                <span class="aicon-arrow-up"></span>
                                <p class="name">泡沫箱</p>
                                <p class="description">保温隔热、缓冲抗震；用于生鲜件的保温</p>
                            </div>
                        </div>
                        <div class="tab-list">
                            <img src="@/assets/images/package-service/inflatable-bag.png" alt="包装材料展示图片" />
                            <div class="content">
                                <span class="aicon-arrow-up"></span>
                                <p class="name">保温袋</p>
                                <p class="description">加强温控；用于泡沫箱内包装使用，加强控温效果</p>
                            </div>
                        </div>
                    </div>
                    <div class="fee">
                        <p class="fee-title">冰袋收费标准</p>
                        <table class="three">
                            <tbody>
                                <tr>
                                    <th>包装名称</th>
                                    <th>尺寸</th>
                                    <th>价格</th>
                                </tr>
                                <tr>
                                    <td>冷藏冰袋小号</td>
                                    <td>150mm*105mm</td>
                                    <td>1元/个</td>
                                </tr>
                                <tr>
                                    <td>冷藏冰袋中号</td>
                                    <td>170mm*120mm</td>
                                    <td>1元/个</td>
                                </tr>
                                <tr>
                                    <td>冷藏冰袋大号</td>
                                    <td>195mm*135mm</td>
                                    <td>1元/个</td>
                                </tr>
                                <tr>
                                    <td>冷冻冰袋小号</td>
                                    <td>150mm*105mm</td>
                                    <td>1元/个</td>
                                </tr>
                                <tr>
                                    <td>冷冻冰袋中号</td>
                                    <td>170mm*120mm</td>
                                    <td>1元/个</td>
                                </tr>
                                <tr>
                                    <td>冷冻冰袋大号</td>
                                    <td>195mm*135mm</td>
                                    <td>1元/个</td>
                                </tr>
                                <tr>
                                    <td>深冻冰袋小号</td>
                                    <td>150mm*105mm</td>
                                    <td>1元/个</td>
                                </tr>
                                <tr>
                                    <td>深冻冰袋中号</td>
                                    <td>170mm*120mm</td>
                                    <td>1元/个</td>
                                </tr>
                                <tr>
                                    <td>深冻冰袋大号</td>
                                    <td>195mm*135mm</td>
                                    <td>1元/个</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="fee">
                        <p class="fee-title">泡沫箱收费标准</p>
                        <table class="three">
                            <tbody>
                                <tr>
                                    <th>包装名称</th>
                                    <th>尺寸</th>
                                    <th>价格</th>
                                </tr>
                                <tr>
                                    <td>泡沫箱1号</td>
                                    <td>30cm*20cm*22.5cm</td>
                                    <td>3元/个</td>
                                </tr>
                                <tr>
                                    <td>泡沫箱2号</td>
                                    <td>40cm*27cm*20cm</td>
                                    <td>5元/个</td>
                                </tr>
                                <tr>
                                    <td>泡沫箱红酒1瓶装</td>
                                    <td>35cm*10.5cm*10.5cm</td>
                                    <td>1元/个</td>
                                </tr>
                                <tr>
                                    <td>泡沫箱红酒2瓶装</td>
                                    <td>35cm*21cm*10.5cm</td>
                                    <td>2元/个</td>
                                </tr>
                                <tr>
                                    <td>泡沫箱奶粉1罐装</td>
                                    <td>15.5cm*15.5cm*19.5cm</td>
                                    <td>1元/个</td>
                                </tr>
                                <tr>
                                    <td>泡沫箱奶粉2罐装</td>
                                    <td>31cm*15.5cm*19.5cm</td>
                                    <td>2元/个</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="fee">
                        <p class="fee-title">保温袋收费标准</p>
                        <table class="three">
                            <tbody>
                                <tr>
                                    <th>包装名称</th>
                                    <th>尺寸</th>
                                    <th>价格</th>
                                </tr>
                                <tr>
                                    <td>珍珠棉保温袋1号</td>
                                    <td>42cm*40cm*2mm</td>
                                    <td>1元/个</td>
                                </tr>
                                <tr>
                                    <td>珍珠棉保温袋2号</td>
                                    <td>75cm*53.5cm*2mm</td>
                                    <td>1元/个</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="type-mark">
                        <p>注：</p>
                        <div><p>以上收费标准及实际可提供的包装可能因服务（产品）或所在地区不同而有所差异，详情请咨询当地收派员</p></div>
                    </div>
                </section>
                <section v-show="type === 'buffer'" data-toggle="#buffer">
                    <div class="tab-img">
                        <div class="tab-list">
                            <img src="@/assets/images/package-service/cardboard.png" alt="包装材料展示图片" />
                            <div class="content">
                                <span class="aicon-arrow-up"></span>
                                <p class="name">纸板</p>
                                <p class="description">缓冲减震；用于易碎类物品的内包装</p>
                            </div>
                        </div>
                        <div class="tab-list">
                            <img src="@/assets/images/package-service/inflatable-bag.png" alt="包装材料展示图片" />
                            <div class="content">
                                <span class="aicon-arrow-up"></span>
                                <p class="name">充气袋</p>
                                <p class="description">抗震防护，方便安全；用于各类物品的内包装</p>
                            </div>
                        </div>
                        <div class="tab-list">
                            <img src="@/assets/images/package-service/pearl-cotton.png" alt="包装材料展示图片" />
                            <div class="content">
                                <span class="aicon-arrow-up"></span>
                                <p class="name">珍珠棉</p>
                                <p class="description">缓冲减震，易于包装；用于易碎类物品的内包装</p>
                            </div>
                        </div>
                        <div class="tab-list">
                            <img src="@/assets/images/package-service/bubble-film.png" alt="包装材料展示图片" />
                            <div class="content">
                                <span class="aicon-arrow-up"></span>
                                <p class="name">气泡膜</p>
                                <p class="description">缓冲减震，适用性强；用于各类物品的内包装</p>
                            </div>
                        </div>
                    </div>
                    <div class="fee">
                        <p class="fee-title">纸板收费标准</p>
                        <table class="three">
                            <tbody>
                                <tr>
                                    <th>包装名称</th>
                                    <th>尺寸</th>
                                    <th>价格</th>
                                </tr>
                                <tr>
                                    <td>普通纸板</td>
                                    <td>200cm*100cm*0.6cm</td>
                                    <td>4元/个</td>
                                </tr>
                                <tr>
                                    <td>蜂窝纸板</td>
                                    <td>100cm*100cm*3cm</td>
                                    <td>12元/个</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="fee">
                        <p class="fee-title">充气袋收费标准</p>
                        <table class="three">
                            <tbody>
                                <tr>
                                    <th>包装名称</th>
                                    <th>尺寸</th>
                                    <th>价格</th>
                                </tr>
                                <tr>
                                    <td>充气袋红酒1瓶装</td>
                                    <td>42cm*24cm*3cm*0.07cm</td>
                                    <td>1元/个</td>
                                </tr>
                                <tr>
                                    <td>充气袋红酒2瓶装</td>
                                    <td>42cm*48cm*3cm*0.07cm</td>
                                    <td>1元/个</td>
                                </tr>
                                <tr>
                                    <td>充气袋手机1台装</td>
                                    <td>40cm*30cm*3cm*0.07cm</td>
                                    <td>1元/个</td>
                                </tr>
                                <tr>
                                    <td>充气袋笔记本1台装</td>
                                    <td>51cm*45cm*3cm*0.07cm</td>
                                    <td>1元/个</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="fee">
                        <p class="fee-title">珍珠棉收费标准</p>
                        <table class="three">
                            <tbody>
                                <tr>
                                    <th>包装名称</th>
                                    <th>尺寸</th>
                                    <th>价格</th>
                                </tr>
                                <tr>
                                    <td>珍珠棉卷1号</td>
                                    <td>50m*100cm*0.5cm</td>
                                    <td>1元/件(包裹)</td>
                                </tr>
                                <tr>
                                    <td>珍珠棉卷2号</td>
                                    <td>50m*100cm*1cm</td>
                                    <td>1元/件(包裹)</td>
                                </tr>
                                <tr>
                                    <td>珍珠棉片1号</td>
                                    <td>27cm*30.5cm*1cm</td>
                                    <td>1元/个</td>
                                </tr>
                                <tr>
                                    <td>珍珠棉片2号</td>
                                    <td>27cm*30.5cm*2cm</td>
                                    <td>1元/个</td>
                                </tr>
                                <tr>
                                    <td>珍珠棉片3号</td>
                                    <td>23cm*30.5cm*4cm</td>
                                    <td>1元/个</td>
                                </tr>
                                <tr>
                                    <td>珍珠棉片4号</td>
                                    <td>20cm*30.5cm*5cm</td>
                                    <td>2元/个</td>
                                </tr>
                                <tr>
                                    <td>珍珠棉片5号</td>
                                    <td>20cm*30.5cm*6cm</td>
                                    <td>2元/个</td>
                                </tr>
                                <tr>
                                    <td>珍珠棉片6号</td>
                                    <td>20cm*30.5cm*7cm</td>
                                    <td>2元/个</td>
                                </tr>
                                <tr>
                                    <td>珍珠棉套主机1台装</td>
                                    <td>45cm*24cm*13cm</td>
                                    <td>4元/个</td>
                                </tr>
                                <tr>
                                    <td>珍珠棉套手机1台装</td>
                                    <td>19cm*4cm*9.5cm</td>
                                    <td>1元/个</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="fee">
                        <p class="fee-title">气泡膜收费标准</p>
                        <table class="three">
                            <tbody>
                                <tr>
                                    <th>包装名称</th>
                                    <th>尺寸</th>
                                    <th>价格</th>
                                </tr>
                                <tr>
                                    <td>气泡膜大泡</td>
                                    <td>50m*50cm</td>
                                    <td>免费</td>
                                </tr>
                                <tr>
                                    <td>气泡膜中泡</td>
                                    <td>100m*50cm</td>
                                    <td>免费</td>
                                </tr>
                            </tbody>
                        </table>
                        <div class="fee-mark">
                            <p>注：</p>
                            <div><p>特殊产品的气泡膜收费标准或有不同，详情请致电95338或咨询当地收派员</p></div>
                        </div>
                    </div>
                    <div class="type-mark">
                        <p>注：</p>
                        <div><p>以上收费标准及实际可提供的包装可能因服务（产品）或所在地区不同而有所差异，详情请咨询当地收派员</p></div>
                    </div>
                </section>
                <section v-show="type === 'wooden'" data-toggle="#wooden">
                    <div class="tab-img three">
                        <div class="tab-list">
                            <img src="@/assets/images/package-service/wooden-frame.png" alt="包装材料展示图片" />
                            <div class="content">
                                <span class="aicon-arrow-up"></span>
                                <p class="name">木架</p>
                                <p class="description">强度高，性价比高；用于重型货物，如大型家电家具、汽配、厨卫等</p>
                            </div>
                        </div>
                        <div class="tab-list">
                            <img src="@/assets/images/package-service/wooden-box.png" alt="包装材料展示图片" />
                            <div class="content">
                                <span class="aicon-arrow-up"></span>
                                <p class="name">木箱</p>
                                <p class="description">强度高，防护性能好；用于大精密仪器、机械仪表、医疗器械等</p>
                            </div>
                        </div>
                        <div class="tab-list">
                            <img src="@/assets/images/package-service/wooden-pallets.png" alt="包装材料展示图片" />
                            <div class="content">
                                <span class="aicon-arrow-up"></span>
                                <p class="name">木托盘</p>
                                <p class="description">搬运效率高，装载率高，通用性强；用于多票集装</p>
                            </div>
                        </div>
                    </div>
                    <div class="fee">
                        <p class="fee-title">木质包装收费标准</p>
                        <table class="four">
                            <tbody>
                                <tr>
                                    <th>包装名称</th>
                                    <th>尺寸</th>
                                    <th>价格</th>
                                    <th>备注</th>
                                </tr>
                                <tr>
                                    <td>木架</td>
                                    <td>木架体积=打木架前货物原体积*1.4（体积系数）</td>
                                    <td>200元/立方，最低45元/个</td>
                                    <td>半封闭；木架重量会计入整体实重中</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="fee">
                        <p class="fee-title"></p>
                        <table class="four">
                            <tbody>
                                <tr>
                                    <th>包装名称</th>
                                    <th>尺寸</th>
                                    <th>价格</th>
                                    <th>备注</th>
                                </tr>
                                <tr>
                                    <td>木箱</td>
                                    <td>木箱体积=打木箱前货物原体积*1.4（体积系数）</td>
                                    <td>300元/立方，最低65元/个</td>
                                    <td>全封闭；木箱重量会计入整体实重中</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="fee">
                        <p class="fee-title"></p>
                        <table class="four last-four">
                            <tbody>
                                <tr>
                                    <th>包装名称</th>
                                    <th>尺寸</th>
                                    <th>价格</th>
                                    <th>备注</th>
                                </tr>
                                <tr>
                                    <td>标准托盘</td>
                                    <td>120cm*100cm</td>
                                    <td>60元/个</td>
                                    <td>托盘重量会计入整体实重中</td>
                                </tr>
                                <tr>
                                    <td>非标准托盘</td>
                                    <td>/</td>
                                    <td>50元/平方，最低45元/个</td>
                                    <td>托盘重量会计入整体实重中</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="type-mark">
                        <p>注：</p>
                        <div>
                            <p>泉州地区，木架最低85元/个，木箱最低140元/个</p>
                            <p>上述费用已包含木质包装材料及人工制作费用</p>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    </div>
</template>

<script>
import { mapMutations } from 'vuex'
export default {
    name: 'PackageService',
    components: {},
    props: {
        // 是否隐藏头部
        noHead: {
            type: String,
            default: 'false'
        },
        noFooter: {
            type: String,
            default: 'false'
        }
    },
    data() {
        return {
            type: 'normal'
        }
    },
    computed: {},
    mounted() {
        this.setShowHeader(!(this.noHead === 'true'))
        this.setShowFooter(!(this.noFooter === 'true'))
    },
    methods: {
        ...mapMutations({
            setTitle: 'setTitle',
            setShowHeader: 'setShowHeader',
            setShowFooter: 'setShowFooter'
        }),
        changeType(type) {
            this.type = type
        }
    }
}
</script>

<style lang="scss" scoped>
#container {
    max-width: 750px;
    min-width: 320px;
    margin: 0 auto;
    position: relative;
}
.mail_service .tab_container {
    margin-top: 100px;
    padding: 0 20px;
    position: relative;
}
.mail_service .tab_container .tab_title {
    font-size: 44px;
    text-align: center;
    font-weight: bold;
    margin-bottom: 60px;
}
a,
a:hover {
    text-decoration: none;
    color: #000;
}
body {
    line-height: 1;
}
ol,
ul {
    list-style: none;
}
.clear::after {
    content: '';
    display: block;
    clear: both;
}
.package-services {
    width: 100%;
}
h3.title,
h3.desc-title {
    font-size: 33px;
    font-weight: 700;
    color: #000000;
    padding: 19px 27px;
    background: #ffffff;
}
p.desc-detail {
    background: #fff;
    color: #000000;
    padding: 5px 24px;
}
.list-title div {
    font-family: PingFangSC-Regular;
    display: inline-block;
    height: 36px;
    width: 25%;
    line-height: 30px;
    color: #666666;
    letter-spacing: 0px;
    font-size: 26px;
    text-align: center;
}
.list-title.clear {
    padding-top: 25px;
    padding-bottom: 20px;
    height: 100px;
    background: #fff;
    display: flex;
}
.list-title div.active {
    border-bottom: solid 3px #dc1e32;
    color: #dc1e32;
}
.tab-list {
    margin-bottom: 28px;
    background: #ffffff;
    border: 2px solid #efefef;
}
.tab-img {
    padding: 18px;
}
.tab-list.clear {
    overflow: visible;
    height: auto;
    display: flex;
}
.tab-list img {
    width: 50%;
    height: 50%;
    float: left;
    flex: 1;
}
.tab-list .content {
    text-align: center;
}
.tab-list .content .name {
    font-family: PingFangSC-Medium;
    font-size: 28px;
    padding-top: 49px;
    font-weight: 700;
    color: #5a5454;
}
.tab-list .content .description {
    font-size: 24px;
    line-height: 44px;
    color: #676363;
    padding-top: 10px;
}
.tab-list::after {
    content: '';
    display: block;
    clear: both;
}
table {
    background: #fafafa;
    border: 0.4px solid #ebebeb;
    border-collapse: collapse;
    width: 96%;
    margin-left: 2%;
}
table td {
    vertical-align: middle;
    text-align: center;
    font-size: 21px;
    color: #7e7777;
    padding: 0.1rem;
}
table tr {
    border-bottom: 1px solid #ebebeb;
}
.fee .fee-title {
    font-family: PingFangSC-Semibold;
    font-weight: 700;
    font-size: 31px;
    color: #000000;
    letter-spacing: 0;
    margin: 20px 0;
    line-height: 48px;
    padding-left: 30px;
}
.three tr {
    height: 70px;
}
.three tr > th,
.four tr > th {
    font-size: 30px;
    line-height: 70px;
    color: #333333;
    background: #f5f5f5;
    font-weight: 600;
    width: 25%;
}
.fee-mark {
    padding-top: 24px;
}
.type-mark {
    padding-top: 20px;
}
.fee-mark p,
.type-mark p {
    padding-left: 20px;
    font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/pages/package-service/index.vue